class window.PageResourcesHelper
  constructor: ->
    @staticContentBlock = $(".static-content")
    @staticImages = @staticContentBlock.find("img")

    @initImages()

  initImages: ->
    self = this

    for image, i in @staticImages
      imageTitle = $(image).attr("title")
      if imageTitle != undefined && imageTitle.length > 0
        $(image).after($(@getImageDescriptionBlock(imageTitle)))

  getImageDescriptionBlock: (title) ->
    descriptionBlock = "<small>"+title+"</small>"
    return descriptionBlock

  # здесь может быть ваш хелпер для таблиц


// WEBPACK FOOTER //
// ./assets/javascripts/app/page_resources_helper.coffee